import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarCentros = ({ refresh }) => {
  const [centrosFormacion, setCentrosFormacion] = useState([]);
  const navigate = useNavigate();


  // Función para obtener los datos de centros de formacion
  const getData = useCallback(async () => {
    try {
      // Realiza la solicitud al backend
      const { data } = await axios.get("/api/centrosdeformacion/listall/");

      // Asegúrate de que 'centros' contiene los datos correctamente
      const centrosConFunciones = data.centros.map((centro) => ({
        ...centro,
        nombreRegional: centro.regionalObjectId?.nombreRegional || "Regional no disponible", // Mostrar nombreRegional si está disponible
        funciones: (

          <div className="d-flex gap-2">

            <button
              className="btn btn-warning d-flex align-items-center justify-content-center"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => navigate(`/institucional/centro/${centro._id}`)}
            >
              <i className="fa-solid fa-pen-to-square"></i>
            </button>

            <button
              className="btn btn-danger"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => deleteCentros(centro._id)}
            >
              <i className="fa-solid fa-trash"></i>
            </button>
            
          </div>
        ),
      }));

      setCentrosFormacion(centrosConFunciones.reverse()); // Actualiza el estado con los datos transformados
    } catch (error) {
      console.error("Error al cargar las regionales:", error.message);
    }
    // eslint-disable-next-line 
  }, [navigate]);

  // Ejecutar getData cuando el componente se monte
  useEffect(() => {
    getData();
  }, [getData, refresh]);

  // Función para eliminar una regional
  const deleteCentros = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/centrosdeformacion/${id}`);
          getData(); // Refrescar los datos de la lista
          Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar la regional:', error.message);
      Swal.fire('Error', 'No se pudo eliminar la regional.', 'error');
    }
  };

  const columns = React.useMemo(() => [
    { Header: 'Código', accessor: 'codCentro' },
    { Header: 'Nombre Centro', accessor: 'nombreCentro' },
    { Header: 'Municipio', accessor: 'municipioCentro' },
    { Header: 'Dirección', accessor: 'direccionCentro' },
    { Header: 'Regional', accessor: 'nombreRegional' },
    { accessor: 'funciones' },

  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Listad e Centros</h1>
      {Array.isArray(centrosFormacion) && centrosFormacion.length > 0 ? (
        <DataTable columns={columns} data={centrosFormacion} />
      ) : (
        <p>Cargando Centros de Formación...</p>
      )}

    </div>
  );
};

export default ListarCentros;
